export enum SubmitDepositStatus {
	Initial,
	Previewed,
	Previewing,
	Depositing,
	Deposited,
}
